import { useContext, useEffect } from 'react'
import Head from 'next/head'
import Script from 'next/script'
import Link from 'next/link'
import Image from 'next/image'
import { s3Static } from '../../utils/constants'
import { BlogHeaderLinks } from '../../components/blogs/BlogHeaderLinks'
import { getArticleDateTime } from '../../utils/article-date-time'
import { BlogsList } from '../../components/blogs/BlogList'
import { blogsMaster } from '../../utils/sg-blogs-data'
import { getWpNewPostsByCategory, getWpPostsByCategory } from '../../lib/service'
import { getWpHealthFitness, getWpNewHealthFitness, setWpHealthFitness, setWpNewHealthFitness } from '../../service/wp-blogs-store'

export async function getStaticProps() {

    const { modifiedDate, month, year } = getArticleDateTime();
    const fitnessBlogs = blogsMaster['health-fitness'].blogArray;
    const wpPosts = getWpHealthFitness().length > 0 ?  getWpHealthFitness() : await getWpPostsByCategory(6, "health-fitness");
    setWpHealthFitness(wpPosts)
    const wpNewPosts = getWpNewHealthFitness().length > 0 ?  getWpNewHealthFitness() : await getWpNewPostsByCategory(6, "health-fitness");
    setWpNewHealthFitness(wpNewPosts)

  return {
      props: {
        modifiedDate,
        month,
        year,
        fitnessBlogs
      },
      // Next.js will attempt to re-generate the page:
      // - When a request comes in
      // - At most once every 10 seconds
  }
}

export default function Home(props) {
    const modifiedDate = props.modifiedDate
    const month = props.month
    const year = props.year
    const fitnessBlogs = props.fitnessBlogs
    const wpPosts = props.wpPosts
    const wpNewPosts = props.wpNewPosts

  return (
    <>
      <Head>
        <title>TRX Exercises | The TRX Suspension Trainer</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no"/>
        <meta name="description" content="TRX also known as Total Resistance exercises. The best thing is that this TRX can be used by people at all fitness levels as it mainly requires the trainee to use his/her own body weight to exercise."/>
        <meta name="keywords" content="House Rental, Insurance Plan, Personal Trainer, Maid Service, Handyman Service, Aircon Service, Savings Plan, Food Catering, Interior Design, Wedding Planner, Event Planner"/>
        <meta name="author" content="StringsSG"/>
        <meta name="google-site-verification" content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:url"   content="https://www.stringssg.com/blogs/trx-exercises-that-you-can-do" />
        <meta property="og:type"   content="article" />
        <meta property="og:title"    content={`TRX Exercises | The TRX Suspension Trainer`}/>
        <meta property="og:description" content="TRX also known as Total Resistance exercises. The best thing is that this TRX can be used by people at all fitness levels as it mainly requires the trainee to use his/her own body weight to exercise." />
        <meta property="article:publisher" content="https://www.facebook.com/StringsSG/" />
        <meta property="article:published_time" content="2025-01-08T07:30:46+00:00" />
        <meta property="article:modified_time" content="2025-01-04T07:30:46+00:00" />
        <meta property="og:image"  content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/health+and+fitness/girl-trx-pushup.webp" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/health+and+fitness/girl-trx-pushup.webp" />
        <meta name="twitter:site" content="@stringssg"/> 
        <meta name="twitter:url" content="https://www.stringssg.com/blogs/trx-exercises-that-you-can-do"/>
        <meta name="twitter:title" content={`TRX Exercises | The TRX Suspension Trainer`}/> 
        <meta name="twitter:description" content="TRX also known as Total Resistance exercises. The best thing is that this TRX can be used by people at all fitness levels as it mainly requires the trainee to use his/her own body weight to exercise."/>
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href="https://www.stringssg.com/blogs/trx-exercises-that-you-can-do" />
        <script type="application/ld+json"
          dangerouslySetInnerHTML={{ __html:
            `{"@context":"https://schema.org","@graph":[{"@context":"https://schema.org/","@type":"BlogPosting","mainEntityOfPage":{"@type":"WebPage","@id":"https://www.stringssg.com/blogs/trx-exercises-that-you-can-do"},"headline":"TRX Exercises | The TRX Suspension Trainer","description":"TRX also known as Total Resistance exercises. The best thing is that this TRX can be used by people at all fitness levels as it mainly requires the trainee to use his/her own body weight to exercise","image":["https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/health+and+fitness/girl-trx-pushup.webp"],"author":{"@type":"Organization","@id":"https://www.stringssg.com/#organization","name":"StringsSG","url":"https://www.stringssg.com/"},"publisher":{"@type":"Organization","@id":"https://www.stringssg.com/#organization","name":"StringsSG","url":"https://www.stringssg.com/","logo":{"@type":"ImageObject","url":"https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/logo.png"}},"datePublished":"2025-01-08T07:30:46+00:00","dateModified":"2022-09-04T07:30:46+00:00"},{"@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Blogs","item":"https://www.stringssg.com/blogs"},{"@type":"ListItem","position":1,"name":"TRX"}]}]}`
          }}
        />
        </Head>
        <div className='max-w-5xl mx-auto py-5 px-2'>
            <div className='space-y-2'>
                <h1 className='text-lg text-gray-500 font-semibold'>TRX Exercises | The TRX Suspension Trainer</h1>
                <div className='text-gray-400 text-xs'>
                    <time dateTime="2022-09-09 00:00">September 9th 2022</time>
                </div>
            </div>
            <div className='py-2 text-gray-500 leading-8 space-y-2'>
                <div className='py-2'>
                    <p className=''>
                    The TRX Suspension Trainer is perhaps on the best workout system. It is also known as Total Resistance exercises. The best thing is that this TRX can be used by people at all fitness levels as it mainly requires the trainee to use his/her own body weight to exercise. This is a specialized form of suspension training that helps to develop core stability, flexibility, body strength, balance etc. However, it is very important that we do all the forms correctly and do not injure ourselves. There are specialized and certified TRX Suspension Trainers for the purpose and it is a safer idea to have a personal trainer or TRX trainer to train us in order to yield maximum benefits from this tool.
                    </p>
                </div>
                <div className='relative h-96 max-w-xl'>
                    <Image className='rounded-lg'
                            src={s3Static + "blog/health+and+fitness/girl-trx-pushup.webp"}
                            fill
                            style={{objectFit: 'cover'}}
                            placeholder='blur'
                            blurDataURL={s3Static + "placeholder.png"}
                            alt='girl doing trx pushups'
                    />          
                </div>
                <div className='py-2 space-y-2'>
                    <h2 className='font-bold uppercase'>
                        Benefits we get from working out with TRX Suspension Trainer
                    </h2>
                    <ul className='list-decimal space-y-2 p-6'>
                        <li>
                        It is a total-body workout that benefits people of all fitness levels.
                        </li>
                        <li>
                        Exercising with TRX helps to improve both mobility and stability.
                        </li>
                        <li>
                        It helps develop functional strength.
                        </li>
                        <li>
                        The best part is it does not necessarily be a gym, but it can be set-up anywhere like outdoors, home or even in hotels!
                        </li>
                        <li>
                        This TRX Suspension Trainer gives much greater performance than many of those large and expensive exercise machines.
                        </li>
                        <li>
                        Moreover, it helps to increase our metabolic results too.
                        </li>
                        <li>
                        TRX Suspension Trainer is great for strength training, increasing muscular endurance and for building lean muscles.
                        </li>
                        <li>
                        One of the major benefits working out with TRX is it makes our core very strong and stable.
                        </li>
                    </ul>
                </div>
                
                <div className='py-2 space-y-2'>
                    <h2 className='font-bold uppercase'>
                        Some of the popular TRX workouts are:
                    </h2>
                    <p>
                        <strong>TRX Push up</strong> – It is known to all of us that push-up is still one of the most dependable exercises when it comes to weight loss, muscle building or toning. Other than the on the floor style, doing push-ups on TRX suspension trainer gives our body a total new dimension.
                    </p>
                    <p>
                    For this we need to stand facing away from the TRX. We have to hold the handles of the TRX right at the chest height with extended arms and our palms should be facing the floor. Our feet should be kept apart too i.e. it should be shoulder-width apart and body should be aligned from head to heels. Now we have to shift our body weight to the balls of our feet and bend our elbows. Thus do the push up and return to starting position again.
                    </p>
                    <p>
                        <strong>Lunges </strong> – Lunges are again very popular and common fitness exercise. It improves our lower limb strength and balance. It is a very good functional exercise that betters our overall function of legs.
                    </p>
                    <p>
                    All we need to do is stand facing away from the TRX, one foot should be on the foot cradle and hands on hips. Now we have to bend our knees until the other thigh is parallel to the floor. Thereafter, we have to rise up to starting position. The same movement needs to be repeated on the other leg. Together that’s one set.
                    </p>
                    <p>
                        <strong>Triceps Extension</strong> – For this exercise, we need to stand underneath the anchor point, facing the TRX. Lean forward and hold both the handles and extend our arms in the front. Our elbows should bent 90 degrees and our palms should face away from us. Now we have to raise the handles of the TRX towards our eye level, while keeping our palms facing towards the floor and our arms must be extended. Then we need to return to the position where we started from.
                    </p>
                    <p>
                        <strong>High Bicep curls</strong> – At first we need to stand with feet hip-width apart, facing away from the TRX. Thereafter, we have to hold the handles by leaning forward. Our elbows should be bent at 90 degrees while it is important to keep our palms facing away from us. Thereafter we need to extend our arms followed by bending our elbows to return to starting position.
                    </p>
                    <p>
                    Other exercises are like –  TRX Chest Press, Kneeling Triceps Press, Low Row, Alligator, Glute Bridge, Single-Leg Squat etc. All of these exercises are very good for weight loss, muscle building and toning. However, proper guidance as to how to move about with these workouts is very essential for which it is recommended to have a personal trainer or TRX trainer who is certified for the same.
                    </p>
                </div>
                <div className='py-2 text-center'>
                    <Link href="/sg/personal-trainer" className='px-3 py-3 border border-amber-600 text-orange-600 rounded-lg'>
                            Find a TRX and suspension training coach
                    </Link>
                </div>
            </div>
            <BlogsList blogs={fitnessBlogs} wpPosts={wpPosts} wpNewPosts={wpNewPosts}/>
        </div>
        <div className='fixed bottom-0 w-full text-center text-lg'>
            <Link href="/sg/personal-trainer" prefetch={false} className='text-white py-3 bg-linear-to-tr from-amber-600 to-amber-400 block font-bold w-full'>
                    Find a TRX and suspension training coach
            </Link>
        </div>
        <BlogHeaderLinks/>
        <Script 
            id="google-tagmanager-new"
            src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
            strategy="lazyOnload"
            onLoad={() => {              
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());
            
                gtag('config', 'G-QD1HGGHDYJ');
            }} 
        />
        <Script id="facebook-tracking" strategy="lazyOnload">
          {`!function(f,b,e,v,n,t,s)
					  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
					  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
					  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
					  n.queue=[];t=b.createElement(e);t.async=!0;
					  t.src=v;s=b.getElementsByTagName(e)[0];
					  s.parentNode.insertBefore(t,s)}(window, document,'script',
					  'https://connect.facebook.net/en_US/fbevents.js');
					  fbq('init', '128634041116395');
					  fbq('track', 'PageView');`}
        </Script>
    </>
  )
}
